import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import { Navigate } from "react-router-dom";
import Navbar from "../Component/navbar";
import { API_URL } from "../apiConfig.js";
import DynamicPersonalDetail from "../Component/DynamicPersonalDetail.jsx";
import DynamicEducationInputs from "../Component/DynamicEducationInputs";
import DynamicExperienceInputs from "../Component/DynamicExperienceInputs";
import DynamicSkillsInputs from "../Component/DynamicSkillsInputs";
import DynamicAddInfos from "../Component/DymanicAddInfos";
import DynamicAchivAward from "../Component/DynamicAchivAward";
import DynamicProject from "../Component/DynamicProject";
import SaveDataButton from "../Component/SaveApiData.jsx";
import menu from "../image/menu.png";
import pencil from "../image/pencil.png";
import portfolio from "../image/portfolio.png";
import project from "../image/project.png";
import trophy from "../image/trophy.png";
import user from "../image/user.png";
import graduation from "../image/graduation-cap.png";
import { PDFExport } from "@progress/kendo-react-pdf";
import {
  FaSave,
  FaCogs,
  FaTrash,
  FaAngleLeft,
  FaDownload,
  FaEye,
  FaSpinner,
} from "react-icons/fa";
import {
  BsCloudCheckFill,
  BsCloudUpload,
  BsExclamationTriangleFill,
  BsArrowsFullscreen,
} from "react-icons/bs";
import Toggle from "../Component/Toggle.jsx";
import TemplateSelector from "./TemplateSelector.jsx";
import Template1 from "../Component/Template1";
import Template2 from "../Component/Template2";
import Template3 from "../Component/Template3";
import Hirebeengreen from "../image/Hirebeengreen.svg";
import back from "../image/back.png";
import "./ResumeBuilder.css";
import CSRFToken from "../cookies.js";
import html2canvas from "html2canvas";
import downloadingGif from "../image/downloading.gif";

const arrayToString = (array) => {
  if (!Array.isArray(array)) return array; // If it's not an array, return as it is
  return array.join(", ");
};

const ResumeBuilder = ({ template, fetchDatas }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  //template selector
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  // State to track whether data has been saved successfully
  const [dataSaved, setDataSaved] = useState(false);
  const [aiToken, setAiToken] = useState(
    fetchDatas?.outputData?.available_token || 0
  );
  const prevFormData = useRef(null);

  const [formData, setFormData] = useState({
    res_id: fetchDatas.outputData.res_id,
    res_title: fetchDatas.outputData?.resume_sample_title,
    edu_flag: true,
    Work_flag: true,
    ach_flag: true,
    add_flag: true,
    skill_flag: true,
    pro_flag: true,
    Details: [
      {
        fullName: fetchDatas?.outputData?.name || "",
        email: fetchDatas?.outputData?.email || "",
        phoneNumber: fetchDatas?.outputData?.phone || "",
        address: "",
        website: "",
        linkedin: fetchDatas?.outputData?.linkedin || "",
        github: fetchDatas?.outputData?.github || "",
        about: fetchDatas?.outputData?.summary || "",
      },
    ],
    // education: [{
    //     degree: fetchDatas?.outputData?.education?.[0]?.degree || '',
    //     college: fetchDatas?.outputData?.education?.[0]?.collage_name || '',
    //     location: fetchDatas?.outputData?.education?.[0]?.collage_location|| '',
    //     fromYear:  fetchDatas?.outputData?.education?.[0]?.from_date|| '',
    //     toYear: fetchDatas?.outputData?.education?.[0]?.to_date|| ''
    // }],
    education: (fetchDatas?.outputData?.education || []).map((edu) => ({
      degree: edu.degree || "",
      college: edu.collage_name || "",
      location: edu.collage_location || "",
      fromYear: edu.from_date || "",
      toYear: edu.to_date || "",
    })),
    experience: (fetchDatas?.outputData?.experience || []).map((exp) => {
      let jobDescriptionHTML = "";
      if (Array.isArray(exp.responsibilities)) {
        jobDescriptionHTML = exp.responsibilities
          .map((responsibility) => `<li>${responsibility}</li>`)
          .join("");
        jobDescriptionHTML = `<ul>${jobDescriptionHTML}</ul>`;
      } else {
        jobDescriptionHTML = exp.responsibilities;
      }

      return {
        jobRole: exp.job_role || "",
        companyName: exp.company_name || "",
        companyLocation: exp.job_location || "",
        fromYear: exp.from_date || "",
        toYear: exp.to_date || "",
        jobDescription: jobDescriptionHTML,
      };
    }),
    skills: (fetchDatas?.outputData?.skills || []).map((skill) => ({
      title: skill.skill_title || "",
      skill_list: arrayToString(skill.skill_list) || "",
    })),
    achivawards: (fetchDatas?.outputData?.awards_achievements || []).map(
      (achiv) => ({
        achivaward: achiv || "",
      })
    ),
    addinfodatas: (fetchDatas?.outputData?.additionalInfo || []).map(
      (info) => ({
        addinfodata: info.add_info,
      })
    ),

    addprojects: (fetchDatas?.outputData?.projects || []).map((proj) => {
      let descriptionHTML = "";
      if (Array.isArray(proj.project_description)) {
        descriptionHTML = proj.project_description
          .map((desc) => `<li>${desc}</li>`)
          .join("");
        descriptionHTML = `<ul>${descriptionHTML}</ul>`;
      } else {
        descriptionHTML = proj.project_description;
      }

      return {
        projectname: proj.project_title || "",
        projectplatform: arrayToString(proj.project_techStack) || "",
        description: descriptionHTML,
      };
    }),
    profileImage: "",
  });

  const [showPersonalDetails, setShowPersonalDetails] = useState(true);
  const [showEducation, setShowEducation] = useState(false);
  const [showExperience, setShowExperience] = useState(false);
  const [showSkills, setShowSkills] = useState(false);
  const [showAchivAwards, setShowAchivAwards] = useState(false);
  const [showaddInfos, setShowaddInfos] = useState(false);
  const [showProjects, setShowProjects] = useState(false);

  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [saving, setSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const intervalRef = useRef(null);

  const captureRef = useRef(null);
  const pdfExportComponent = useRef(null);

  const [visible1, setVisible1] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [visible4, setVisible4] = useState(false);
  const [visible5, setVisible5] = useState(false);
  const [visible6, setVisible6] = useState(false);

  const [score, setScore] = useState(0);
  const [scaleRatio, setScaleRatio] = useState(1);

  const togglePreview = () => {
    setShowPreview(!showPreview);
  };

  const processExperienceData = () => {
    const experienceData = fetchDatas?.outputData?.experience || []; // Ensure experienceData is an array

    const experience = experienceData.map((exp) => {
      let jobDescriptionHTML = "";
      if (Array.isArray(exp.responsibilities)) {
        jobDescriptionHTML = exp.responsibilities
          .map((responsibility) => `<li>${responsibility}</li>`)
          .join("");
        jobDescriptionHTML = `<ul>${jobDescriptionHTML}</ul>`;
      } else {
        jobDescriptionHTML = exp.responsibilities;
      }

      return {
        jobRole: exp.job_role || "",
        companyName: exp.company_name || "",
        companyLocation: exp.job_location || "",
        fromYear: exp.from_date || "", // Assuming from_date is the property for the start year
        toYear: exp.to_date || "", // Assuming to_date is the property for the end year
        jobDescription: jobDescriptionHTML,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      experience: experience,
    }));
  };

  const processProjectData = () => {
    const addprojectData = fetchDatas?.outputData?.projects || [];

    const addprojects = addprojectData.map((proj) => {
      let descriptionHTML = "";
      if (Array.isArray(proj.project_description)) {
        descriptionHTML = proj.project_description
          .map((desc) => `<li>${desc}</li>`)
          .join("");
        descriptionHTML = `<ul>${descriptionHTML}</ul>`;
      } else {
        descriptionHTML = proj.project_description;
      }

      return {
        projectname: proj.project_title || "",
        projectplatform: arrayToString(proj.project_techStack) || "",
        description: descriptionHTML,
      };
    });

    setFormData((prevState) => ({
      ...prevState,
      addprojects: addprojects,
    }));
  };

  const processEducationData = () => {
    const educationData = fetchDatas?.outputData?.education || [];

    const education = educationData.map((edu) => ({
      degree: edu.degree || "",
      college: edu.collage_name || "",
      location: edu.collage_location || "",
      fromYear: edu.from_date || "",
      toYear: edu.to_date || "",
    }));
    setFormData((prevState) => ({
      ...prevState,
      education: education,
    }));
  };

  const processSkillsData = () => {
    const addSkillsData = fetchDatas?.outputData?.skills || [];

    const skills = addSkillsData.map((skill) => ({
      title: skill.skill_title || "",
      skill_list: arrayToString(skill.skill_list) || "",
    }));
    setFormData((prevState) => ({
      ...prevState,
      skills: skills,
    }));
  };

  const processAddInfoData = () => {
    const addInfoData = fetchDatas?.outputData?.additionalInfo || [];

    const addinfodata = addInfoData.map((info) => ({
      addinfodata: info.add_info,
    }));

    setFormData((prevState) => ({
      ...prevState,
      addinfodatas: addinfodata,
    }));
  };

  const processAchivmentData = () => {
    const addAchivmentData = fetchDatas?.outputData?.awards_achievements || [];

    const Achivmentdata = addAchivmentData.map((addAchiv) => ({
      achivawards: addAchiv || "",
    }));
    setFormData((prevState) => ({
      ...prevState,
      achivawards: Achivmentdata,
    }));
  };

  useEffect(() => {
    processExperienceData();
    processEducationData();
    processProjectData();
    processSkillsData();
    processAddInfoData();
    processAchivmentData();
  }, []);


  const handleScreenshot = () => {
    const element = captureRef.current;
    if (element) {
      html2canvas(element)
        .then((canvas) => {
          const imgData = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = imgData;
          link.download = "screenshot.png";
          link.click();
        })
        .catch((err) => {
          console.error("Screenshot capture failed:", err);
        });
    }
  };
  const captureResumeImage = async () => {
    const printArea = document.getElementById("printArea");
    const canvas = await html2canvas(printArea);
    const imageData = canvas.toDataURL("image/png");
    return imageData;
  };

  const saveFormData = async () => {
    // console.log(formData.Details);
    // console.log(formData.addprojects);
    // console.log("-------")
    // console.log("Form_data", formData)
    // console.log("Prev data", prevFormData.current);
    try {
      if (dataSaved) {
        // console.log('Data unchanged. Skipping API call.');
        setDataSaved(true); // Data is already saved
        return;
      }
      const authToken = localStorage.getItem("access");
      setIsSaving(true); // Show loader
      setError(null);

      const resumeImageData = await captureResumeImage();

      const details = formData.Details[0];

      // Access fields from the details object
      const email = details.email;
      const fullName = details.fullName;
      const phoneNumber = details.phoneNumber;
      const address = details.address;
      const about = details.about;
      const res_title = formData.res_title;

      const transformedHandleLinks = formData.Details.flatMap((detail) => [
        {
          res_id: fetchDatas.outputData.res_id,
          handle_name: "LinkedIn",
          link: detail.linkedin,
        },
        {
          res_id: fetchDatas.outputData.res_id,
          handle_name: "GitHub",
          link: detail.github,
        },
        {
          res_id: fetchDatas.outputData.res_id,
          handle_name: "Website",
          link: detail.website,
        },
      ]);

      const transformedWorkExperience = formData.experience.map((exp) => ({
        res_id: fetchDatas.outputData.res_id,
        job_role: exp.jobRole,
        company_name: exp.companyName,
        job_location: exp.companyLocation,
        from_date: exp.fromYear,
        to_date: exp.toYear,
        responsibilities: exp.jobDescription,
      }));

      // Transform education data
      const transformedEducation = formData.education.map((edu) => ({
        res_id: fetchDatas.outputData.res_id,
        degree: edu.degree,
        collage_name: edu.college,
        collage_location: edu.location,
        from_date: edu.fromYear,
        to_date: edu.toYear,
      }));

      const transformedProjects = formData.addprojects.map((proj) => ({
        res_id: fetchDatas.outputData.res_id,
        project_title: proj.projectname,
        project_techStack: proj.projectplatform,
        project_description: proj.description,
      }));

      // Transform skills data
      const transformedSkills = formData.skills.map((sk) => ({
        res_id: fetchDatas.outputData.res_id,
        skill_title: sk.title,
        skill_list: sk.skill_list,
      }));

      // Transform extra_info data
      const transformedExtraInfo = formData.addinfodatas.map((info) => ({
        res_id: fetchDatas.outputData.res_id,
        add_info: info.addinfodata,
      }));

      // Make a POST request to your Django REST API endpoint
      const response = await axios.post(
        `${API_URL}/save`,
        {
          res_id: fetchDatas.outputData.res_id,
          email: email,
          first_name: fullName,
          last_name: "",
          phone: phoneNumber,
          current_location: address,
          about_me: about,
          handle_links: transformedHandleLinks,
          work_experience: transformedWorkExperience,
          education: transformedEducation,
          projects: transformedProjects,
          skills: transformedSkills,
          extra_info: transformedExtraInfo,
          resume_image: resumeImageData,
          profile_pic: formData.Details[0].profileImage,
          res_title: res_title,
        },
        {
          headers: {
            "X-CSRFToken": CSRFToken(document.cookie),
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      // Check if the request was successful
      if (response.status === 200) {
        setDataSaved(true); // Data saved successfully
        prevFormData.current = formData; // Update the reference to the latest formData
        setSaveStatus("success");
      } else {
        setError("Failed to save data.");
      }
      // console.log("*******")
      // console.log(formData)
    } catch (error) {
      console.error("Error saving data:", error);
      setDataSaved(false); // Data saving failed
      setSaveStatus("failed");
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    const startAutoSave = () => {
      intervalRef.current = setInterval(() => {
        saveFormData();
      }, 30000); // Autosave every 30 seconds
    };

    startAutoSave();

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [dataSaved]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
    setDataSaved(false);
  };

  // Set prevFormData.current when the component mounts
  // useEffect(() => {
  //     prevFormData.current = useRef(null);
  // }, []);

  const handleSaveClick = async () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current); // Clear the current interval
    }
    await saveFormData(); // Save data instantly
    intervalRef.current = setInterval(saveFormData, 30000); // Restart the autosave interval
  };

  const handleReset = () => {
    setFormData({
      res_id: fetchDatas.outputData.res_id,
      // resume_sample_title: fetchDatas.outputData?.resume_sample_title,
      edu_flag: true,
      Work_flag: true,
      ach_flag: true,
      add_flag: true,
      skill_flag: true,
      pro_flag: true,
      Details: [
        {
          fullName: "",
          email: "",
          phoneNumber: "",
          address: "",
          website: "",
          linkedin: "",
          github: "",
          about: "",
        },
      ],
      education: [
        { degree: "", college: "", location: "", fromYear: "", toYear: "" },
      ],
      experience: [
        {
          jobRole: "",
          companyName: "",
          companyLocation: "",
          fromYear: "",
          toYear: "",
          jobDescription: "",
        },
      ],
      skills: [{ title: "", skill_list: "" }],
      achivawards: [{ achivaward: "" }],
      addinfodatas: [{ addinfodatas: "" }],
      addprojects: [{ projectname: "", projectplatform: "", description: "" }],
      profileImage: "",
    });
    setVisible1(false);
    setVisible2(false);
    setVisible3(false);
    setVisible4(false);
    setVisible5(false);
    setVisible6(false);
    setDataSaved(false);
  };


  // Function to handle PDF export
  const exportPDF = async () => {
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    setIsDownloading(true); // Set isDownloading to true

    // Wait for 3 seconds
    await wait(2000);

    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }

    setIsDownloading(false); // Set isDownloading to false after download is complete
  };

  useEffect(() => {
    let template_keyer;
    if (fetchDatas?.outputData?.resume_draft?.template_key) {
      template_keyer = fetchDatas.outputData.resume_draft.template_key;
    } else if (fetchDatas?.outputData?.template_key) {
      template_keyer = fetchDatas.outputData.template_key;
    }
    setSelectedTemplate(template_keyer); // Set initial selected template
  }, []); // Empty dependency array to run effect only once on mount

  // Function to render the selected template based on selectedTemplate state
  const renderTemplate = (error, success) => {
    switch (selectedTemplate) {
      case "template1":
        return (
          <Template1 formData={formData} error={error} success={success} />
        );
      case "template2":
        return (
          <Template2 formData={formData} error={error} success={success} />
        );
      case "template3":
        return (
          <Template3 formData={formData} error={error} success={success} />
        );
      default:
        return <p>Please select a template to start building your resume.</p>;
    }
  };

  const toggleEdu = () => {
    setVisible1(!visible1);
    // console.log("Current value of 'visible1':", !visible1);
    setFormData({ ...formData, edu_flag: !formData.edu_flag });
  };

  const toggleWorkExp = () => {
    setVisible2(!visible2);
    // console.log("Current value of 'visible2':", !visible2);
    setFormData({ ...formData, Work_flag: !formData.Work_flag });
  };

  const toggleSkills = () => {
    setVisible3(!visible3);
    // console.log("Current value of 'visible3':", !visible3);
    setFormData({ ...formData, skill_flag: !formData.skill_flag });
  };
  const toggleProject = () => {
    setVisible4(!visible4);
    // console.log("Current value of 'visible4':", !visible4);
    setFormData({ ...formData, pro_flag: !formData.pro_flag });
  };
  const toggleachievements = () => {
    setVisible5(!visible5);
    // console.log("Current value of 'visible4':", !visible5);
    setFormData({ ...formData, ach_flag: !formData.ach_flag });
  };
  const toggleadditions = () => {
    setVisible6(!visible6);
    // console.log("Current value of 'visible6':", !visible6);
    setFormData({ ...formData, add_flag: !formData.add_flag });
  };
  // console.log(fetchDatas.outputData.name);


  useEffect(() => {
    const updateScaleRatio = () => {
      const screenWidth = window.innerWidth;
      let newScaleRatio = 1; // Default ratio

      if (screenWidth <= 1024) {
        // Calculate scale ratio only if screen width is less than or equal to 1024
        newScaleRatio = screenWidth / 1090; // Adjust divisor as needed
      }

      setScaleRatio(newScaleRatio);
    };

    // Call the update function initially
    updateScaleRatio();

    // Update the scale ratio whenever the window is resized
    window.addEventListener("resize", updateScaleRatio);

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("resize", updateScaleRatio);
    };
  }, []);

  useEffect(() => {
    saveFormData();
  }, []);


  useEffect(() => {
    const calculateScore = () => {
      let totalScore = 0;

      // Personal Details
      const personalDetails = formData.Details[0];
      if (personalDetails) {
        const { fullName, phoneNumber, address, github, linkedin, website } =
          personalDetails;
        if (
          fullName ||
          phoneNumber ||
          address ||
          github ||
          linkedin ||
          website
        ) {
          totalScore += 2;
        }
        if (personalDetails.email) {
          totalScore += 5;
        }
        if (personalDetails.about) {
          totalScore += 15;
        }
      }

      // Experience
      if (formData.experience.length > 0) {
        totalScore += 30;
      }

      // Education
      if (formData.education.length > 0) {
        totalScore += 10;
      }

      // Skills
      if (formData.skills.length > 0) {
        totalScore += 15;
      }

      // Additional Info
      if (formData.addinfodatas.length > 0) {
        totalScore += 7;
      }

      // Awards and Achievements
      if (formData.achivawards.length > 0) {
        totalScore += 6;
      }

      setScore(Math.round(totalScore));
      setDataSaved(false); // Set dataSaved to false when the score changes
    };

    calculateScore();
  }, [formData]);

  useEffect(() => {
    const scoreElement = document.getElementById("progress_bar");
    if (scoreElement) {
      scoreElement.style.width = `${score}%`;
    }
  }, [score]);

  return (
    <div className="bg-[#f8fcfd]">
      <div className="sticky top-0 z-50 top_nav">
        <Navbar  />
      </div>
      <div className="flex flex-wrap justify-center max-w-full">
        <div className="flex-1 min-w-[400px] pb-20">
          <div className="bottom_menu_up">
            {/* <div className='flex flex-col flex-wrap content-center justify-center flex-1 py-2 mx-2 text-sm font-semibold bg-white border-black cursor-pointer h-fit border-1 rounded-xl hover:bg-red-300'><FaCogs className='mx-3 w-7 h-7 hover:fill-red-600' />Design</div> */}
            <div className="flex flex-col flex-wrap content-center justify-center flex-1 py-2 mx-2 text-sm font-semibold bg-white border-black cursor-pointer h-fit border-1 rounded-xl">
              <button onClick={handleSaveClick} disabled={saving}>
                <FaDownload className="mx-3 w-7 h-7 hover:fill-red-600" />{" "}
                {saving ? "Saving..." : "Save Now"}
              </button>
            </div>
            <div
              onClick={exportPDF}
              className="flex flex-col flex-wrap content-center justify-center flex-1 py-2 mx-2 text-sm font-semibold bg-white border-black cursor-pointer h-fit border-1 rounded-xl"
            >
              <FaSave className="mx-3 w-7 h-7 hover:fill-red-600" /> Download
            </div>
            <div
              onClick={handleReset}
              className="flex flex-col flex-wrap content-center justify-center flex-1 py-2 mx-2 text-sm font-semibold bg-white border-black cursor-pointer h-fit border-1 rounded-xl"
            >
              <FaTrash className="mx-3 w-7 h-7 hover:fill-red-600" />
              Clear Resume
            </div>
          </div>
          <div className="template_selector">
            <TemplateSelector
              onSelectTemplate={setSelectedTemplate}
              tempId={selectedTemplate}
            />
          </div>

          <div className="score_main">
            <div className="score_header">
              <div className="">
                <span className="indicator">{score}%</span>
                <span className="ml-2 text-gray-500">Resume Score</span>
              </div>
            </div>
            <div className="scorer">
              <div className="progress"></div>
              <div
                id="progress_bar"
                className={`progress_bar w-[${score}%]`}
              ></div>
            </div>
          </div>

          <input
            type="text"
            name="res_title"
            value={formData.res_title}
            onChange={handleInputChange}
            className="resume_title mt-4 ml-4 w-[95%] px-3 py-2 border rounded-xl"
            placeholder="Enter Resume Title"
          />
          {/* Toggle and form inputs sections */}
          <div className="p-3 m-3 delay-700 bg-white rounded-lg shadow-xl cursor-pointer accordion-card">
            <div
              onClick={() => setShowPersonalDetails(!showPersonalDetails)}
              className="flex text-lg font-bold cursor-pointer border-s-black flex-inline "
            >
              <img src={user} alt="user" className="mx-3 w-7 h-7" /> Personal
              Details
            </div>
            {showPersonalDetails && (
              <DynamicPersonalDetail
                inputs={formData.Details}
                aiToken={aiToken}
                resser={formData.res_id}
                setAiToken={setAiToken}
                setInputs={(newDetails) =>
                  setFormData({ ...formData, Details: newDetails })
                }
                setDataSaved={setDataSaved}
              />
            )}
          </div>

          {/* Dynamic Education Inputs */}
          <div className="p-3 m-3 delay-700 bg-white rounded-lg shadow-xl cursor-pointer accordion-card">
            <div
              className="flex"
              onClick={() => setShowEducation(!showEducation)}
            >
              <div className="flex text-lg font-bold cursor-pointer border-s-black flex-inline ">
                <img src={graduation} alt="user" className="mx-3 w-7 h-7" />{" "}
                Education
              </div>{" "}
              <Toggle visible={visible1} onClick={toggleEdu} />
            </div>
            {showEducation && (
              <DynamicEducationInputs
                inputs={formData.education}
                setInputs={(newEducation) =>
                  setFormData({ ...formData, education: newEducation })
                }
                setDataSaved={setDataSaved}
              />
            )}
          </div>

          {/* Dynamic Experience Inputs */}

          <div className="p-3 m-3 delay-700 bg-white rounded-lg shadow-xl cursor-pointer accordion-card">
            <div
              className="flex"
              onClick={() => setShowExperience(!showExperience)}
            >
              <div className="flex text-lg font-bold cursor-pointer border-s-black flex-inline ">
                <img src={portfolio} alt="user" className="mx-3 w-7 h-7" /> Work
                Experience{" "}
              </div>{" "}
              <Toggle visible={visible2} onClick={toggleWorkExp} />
            </div>
            {showExperience && (
              <DynamicExperienceInputs
                inputs={formData.experience}
                aiToken={aiToken}
                setAiToken={setAiToken}
                setInputs={(newExperience) =>
                  setFormData({ ...formData, experience: newExperience })
                }
                setDataSaved={setDataSaved}
              />
            )}
          </div>
          <div className="p-3 m-3 delay-700 bg-white rounded-lg shadow-xl cursor-pointer accordion-card">
            <div className="flex" onClick={() => setShowSkills(!showSkills)}>
              <div className="flex text-lg font-bold cursor-pointer border-s-black flex-inline ">
                <img src={pencil} alt="user" className="mx-3 w-7 h-7" /> Skills{" "}
              </div>
              <Toggle visible={visible3} onClick={toggleSkills} />
            </div>
            {showSkills && (
              <DynamicSkillsInputs
                inputs={formData.skills}
                setInputs={(newSkills) =>
                  setFormData({ ...formData, skills: newSkills })
                }
                setDataSaved={setDataSaved}
              />
            )}
          </div>

          <div className="p-3 m-3 delay-700 bg-white rounded-lg shadow-xl cursor-pointer accordion-card">
            <div
              className="flex"
              onClick={() => setShowProjects(!showProjects)}
            >
              <div className="flex text-lg font-bold cursor-pointer border-s-black flex-inline ">
                <img src={project} alt="user" className="mx-3 w-7 h-7" />{" "}
                Projects Developed OR Handled
              </div>{" "}
              <Toggle visible={visible4} onClick={toggleProject} />
            </div>
            {showProjects && (
              <DynamicProject
                inputs={formData.addprojects}
                aiToken={aiToken}
                setAiToken={setAiToken}
                setInputs={(newAddproject) =>
                  setFormData({ ...formData, addprojects: newAddproject })
                }
                setDataSaved={setDataSaved}
              />
            )}
          </div>
          <div className="p-3 m-3 delay-700 bg-white rounded-lg shadow-xl cursor-pointer accordion-card">
            <div
              className="flex"
              onClick={() => setShowAchivAwards(!showAchivAwards)}
            >
              <div className="flex text-lg font-bold cursor-pointer border-s-black flex-inline ">
                <img src={trophy} alt="user" className="mx-3 w-7 h-7" /> Awards
                & Achivements{" "}
              </div>
              <Toggle visible={visible5} onClick={toggleachievements} />
            </div>
            {showAchivAwards && (
              <DynamicAchivAward
                inputs={formData.achivawards}
                setInputs={(newAchivAwards) =>
                  setFormData({ ...formData, achivawards: newAchivAwards })
                }
                setDataSaved={setDataSaved}
              />
            )}
          </div>
          <div className="p-3 m-3 delay-700 bg-white rounded-lg shadow-xl cursor-pointer accordion-card ">
            <div
              className="flex"
              onClick={() => setShowaddInfos(!showaddInfos)}
            >
              <div className="flex text-lg font-bold cursor-pointer border-s-black flex-inline">
                <img src={menu} alt="user" className="mx-3 w-7 h-7" />{" "}
                Additional Information
              </div>
              <Toggle visible={visible6} onClick={toggleadditions} />
            </div>
            {showaddInfos && (
              <DynamicAddInfos
                inputs={formData.addinfodatas}
                setInputs={(newAddInfos) =>
                  setFormData({ ...formData, addinfodatas: newAddInfos })
                }
                setDataSaved={setDataSaved}
              />
            )}
          </div>
        </div>
        <div
          className={`flex-1 px-5 pb-20 pt-2 border-l-2 sticky min-w-[400px] right_panel ${
            isDownloading ? "resume-visible" : ""
          }`}
        >
          <TemplateSelector onSelectTemplate={setSelectedTemplate} />
          <div className="flex justify-between mr-3">
            <div className="previewBtn" onClick={togglePreview}>
              <BsArrowsFullscreen className="mr-1 font-extrabold" /> Preview
            </div>
            <div className="px-2 py-1 mb-2 rounded-lg save-status bg-slate-500 w-fit">
              {isSaving ? (
                <div className="flex flex-wrap items-center justify-center gap-1 text-sm">
                  <FaSpinner className="text-xl icon animate-spin" />
                  <span className="text-white">Saving...</span>
                </div>
              ) : saveStatus === "success" ? (
                <div className="flex flex-wrap items-center justify-center gap-1 text-sm">
                  <BsCloudCheckFill className="text-xl icon" />
                  <span className="text-white">Saved</span>
                </div>
              ) : saveStatus === "failed" ? (
                <div className="flex flex-wrap items-center justify-center gap-1 text-sm">
                  <BsExclamationTriangleFill className="text-xl icon" />
                  <span className="text-white">Failed AutoSave</span>
                </div>
              ) : null}
            </div>
          </div>
          <div className="ml-[-10px] w-full border-2 border-gray-600">
            <div id="printArea" ref={captureRef}>
              <PDFExport
                ref={pdfExportComponent}
                paperSize="A4"
                fileName={
                  fetchDatas?.outputData?.name +
                  `_Resume${new Date().getFullYear()}`
                }
                author="https://ResumeBeen.com"
              >
                {renderTemplate()}
              </PDFExport>
            </div>
          </div>
        </div>
      </div>

      {showPreview && (
        <div className="preview-overlay">
          <div className="outer-modal">
            <button onClick={togglePreview} className="close-preview-button">
              X
            </button>
            <div className="preview-modal">
              <div className="temp_in">
                <div
                  className="py-3 transformer"
                  style={{ transform: `scale(${scaleRatio})` }}
                >
                  <div className="preview-content">
                    <div
                      id="printArea"
                      className="border-[3px] border-gray-300 rounded-xl shadow-xl mb-4"
                    >
                      <PDFExport
                        paperSize="A4"
                        className="h-0.5"
                        fileName={
                          fetchDatas?.outputData?.name +
                          `_Resume${new Date().getFullYear()}`
                        }
                        author="https://esumeBeen.com"
                      >
                        {renderTemplate()}
                      </PDFExport>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {isDownloading && (
        <div className="download-overlay">
          <img
            src={downloadingGif}
            alt="Downloading"
            className="download-overlay-gif"
          />
          <span className="download-overlay-text">Downloading...</span>
        </div>
      )}

      <div className="floating_save">
        <div className="px-2 py-1 mb-2 rounded-lg save-status bg-slate-500 w-fit">
          {isSaving ? (
            <div className="flex flex-wrap items-center justify-center gap-1 text-sm">
              <FaSpinner className="text-xl icon animate-spin" />
              <span className="text-white">Saving...</span>
            </div>
          ) : saveStatus === "success" ? (
            <div className="flex flex-wrap items-center justify-center gap-1 text-sm">
              <BsCloudCheckFill className="text-xl icon" />
              <span className="text-white">Saved</span>
            </div>
          ) : saveStatus === "failed" ? (
            <div className="flex flex-wrap items-center justify-center gap-1 text-sm">
              <BsExclamationTriangleFill className="text-xl icon" />
              <span className="text-white">Failed AutoSave</span>
            </div>
          ) : null}
        </div>
      </div>

      <div className="bottom_nav">
        {/* Bottom menu */}
        {/* <button className="menu-button" ><FaCogs className="text-base"/>Design</button> */}
        <button
          className="menu-button"
          onClick={handleSaveClick}
          disabled={saving}
        >
          <FaSave className="text-base" />
          {saving ? "Saving..." : "Save"}
        </button>
        <button className="menu-button" onClick={togglePreview}>
          <FaEye className="text-base" />
          Preview
        </button>
        <button className="menu-button" onClick={exportPDF}>
          <FaDownload className="text-base" />
          Download
        </button>
        <div className="menu-button" onClick={handleReset}>
          <FaTrash className="text-base" />
          Reset
        </div>
      </div>
    </div>
  );
};

export default ResumeBuilder;
